import { useEffect, useState } from "react";

export const useTrackVtt = (data) => {
  const [subtitleUrl, setSubtitleUrl] = useState("");
  const [subtitleUrlEng, setSubtitleUrlEng] = useState("");
  const [vttText, setVttText] = useState("");
  const [vttTextEng, setVttTextEng] = useState("");

  const getTrack = async (url) => {
    const fetchVtt = async () => {
      try {
        const cacheBuster = `v=${Date.now()}`;
        const response = await fetch(
          `${url}${url.includes("?") ? "&" : "?"}${cacheBuster}`,
          {
            cache: "reload",
          }
        );
        return await response.text();
      } catch (error) {
        console.error("Failed to load subtitles:", error);
        return "";
      }
    };
    return fetchVtt();
  };

  useEffect(() => {
    let url, urlEng;

    const fetchVtt = async (srtUrl) => {
      try {
        let text = await await getTrack(srtUrl);
        if (srtUrl.includes(".srt") || !text.includes("WEBVTT")) {
          text =
            "WEBVTT\n\n" +
            text
              .replace(/\r/g, "")
              .replace(/(\d\d:\d\d:\d\d),(\d\d\d)/g, "$1.$2");
        }
        return text;
      } catch (error) {
        console.error("Failed to load subtitles:", error);
        return "";
      }
    };

    const loadSubtitles = async () => {
      if (data?.srt) {
        const vtt = await fetchVtt(data.srt);
        setVttText(vtt);
        if (vtt) {
          const blob = new Blob([vtt], { type: "text/vtt" });
          url = URL.createObjectURL(blob);
          setSubtitleUrl(url);
        } else {
          setSubtitleUrl(null);
        }
      } else {
        setVttText("");
        setSubtitleUrl(null);
      }

      if (data?.srt_en) {
        const vttEng = await fetchVtt(data.srt_en);
        setVttTextEng(vttEng);
        if (vttEng) {
          const blob = new Blob([vttEng], { type: "text/vtt" });
          urlEng = URL.createObjectURL(blob);
          setSubtitleUrlEng(urlEng);
        } else {
          setSubtitleUrlEng(null);
        }
      } else {
        setVttTextEng("");
        setSubtitleUrlEng(null);
      }
    };

    loadSubtitles();

    return () => {
      if (url) URL.revokeObjectURL(url);
      if (urlEng) URL.revokeObjectURL(urlEng);
    };
  }, [data]);

  return { subtitleUrl, vttText, vttTextEng, subtitleUrlEng };
};
